import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.25 15a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75M16.25 7a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M13.237 9.763a1.75 1.75 0 1 0-2.474 2.474.75.75 0 0 1-1.061 1.061 3.25 3.25 0 1 1 4.596-4.596.75.75 0 1 1-1.06 1.06",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 4.75A2.25 2.25 0 0 0 3.75 7v8A2.25 2.25 0 0 0 6 17.25h4a.75.75 0 0 1 0 1.5H6A3.75 3.75 0 0 1 2.25 15V7A3.75 3.75 0 0 1 6 3.25h12A3.75 3.75 0 0 1 21.75 7v3a.75.75 0 0 1-1.5 0V7A2.25 2.25 0 0 0 18 4.75z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m21.75 13.499-.001.043.001 6.858v.001c0 .493-.254.887-.55 1.167-.294.278-.68.494-1.093.66-.833.333-1.931.522-3.107.522s-2.274-.19-3.107-.522c-.414-.166-.8-.382-1.093-.66-.296-.28-.55-.674-.55-1.167V13.5c0-.499.272-.884.567-1.146.296-.261.68-.463 1.092-.617.828-.31 1.92-.487 3.091-.487 1.17 0 2.263.177 3.09.487.412.154.797.356 1.092.618.295.26.567.646.568 1.144m-7.963 0 .025-.022c.11-.097.31-.218.623-.336.62-.232 1.527-.391 2.565-.391s1.944.16 2.564.392c.313.117.514.239.624.336l.024.022-.025.023c-.11.097-.31.218-.623.335-.62.233-1.527.392-2.565.392s-1.945-.16-2.564-.392c-.313-.117-.514-.238-.623-.335zm6.304 1.764q.08-.03.158-.063v1.759a.5.5 0 0 1-.061.064c-.11.096-.31.218-.624.335-.62.233-1.526.392-2.565.392s-1.944-.16-2.564-.392c-.313-.117-.513-.238-.623-.335a.5.5 0 0 1-.062-.065v-1.757q.077.032.158.062c.827.31 1.92.487 3.09.487 1.172 0 2.265-.177 3.093-.487M13.75 18.7v1.681a.4.4 0 0 0 .08.096c.11.104.311.233.62.357.616.246 1.517.415 2.55.415 1.034 0 1.934-.169 2.55-.415.309-.124.51-.253.62-.357a.4.4 0 0 0 .08-.096V18.7l-.159.063c-.828.31-1.92.487-3.092.487-1.17 0-2.263-.177-3.091-.487z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }